export const isMac = () => window.navigator.platform.includes('Mac');
